import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/stonecode_file_mime_types/{?id}')
@doc.timestampable
abstract class AbstractStonecodeFileMimeTypeModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		'partial': string;
		'reference': Website_StonecodeFileMimeTypeReference;
		'typeMimeTypes.type': id;
		'typeMimeTypes.type.reference': Website_StonecodeFileTypeReference;
	};

	declare private _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
		reference: string;
	};

	@doc.string declare reference: Website_StonecodeFileMimeTypeReference;
}

interface AbstractStonecodeFileMimeTypeModel extends Timestampable {}

export default AbstractStonecodeFileMimeTypeModel;
